import { useEffect, useState } from "react";
import { 
  findAllInstitutions, 
  findInstitutionsResumo,
  inactivateInstitution, 
  activateInstitution,
  inactivateInstitutions,
  activateInstitutions, 
} from "../../../../API/apiParceiros";
import { Parceiro, ParceiroResumo } from "../../../../types/Parceiros";
import { PaginationType } from "../../../../types/Pagination";
import { exportPDF } from "utils/exporters/exportPDF";
import { exportXLSX } from "utils/exporters/exportXLSX";
import { ExportColumn } from "types/ExportTypes";

export const useParceiro = () => {

  const [msgError, setMsgError ] = useState<string | null>(null);
  const [msgSuccess, setMsgSuccess ] = useState<string | null>(null);
  const [loading, setLoading] = useState< boolean>(false);
  const [loadingConfirm, setLoadingConfirm] = useState< boolean>(false);
  const [loadingExport, setLoadingExport] = useState<boolean>(false);
  const [parceiros, setParceiros] = useState<Parceiro[]>([]);
  const [parceirosResumo, setParceirosResumo] = useState<ParceiroResumo[]>([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [pagination, setPagination] = useState<PaginationType | null>(null);
  const [searchNome, setSearchNome] = useState<string>("");
  const [searchNomeResp, setSearchNomeResp] = useState<string>("");
  const [searchCnpj, setSearchCnpj] = useState<string>("");
  const [searchEmail, setSearchEmail] = useState<string>("");
  const [searchStatus, setSearchStatus] = useState<number | undefined>(undefined);
  const [openExportPdf, setOpenExportPdf] = useState<boolean>(false);
  const [openExportXls, setOpenExportXls] = useState<boolean>(false);
  
  useEffect(() => {
    buscarParceiros(1, 10);
    buscarParceirosResumo();
  }, []);

  useEffect(() => {
  
    buscarParceiros(currentPage, perPage);
  }, [
    currentPage,
    perPage,
  ]);

  useEffect(() => {
    if (msgSuccess) {
      setTimeout(() => {
        setMsgSuccess(null);
      }, 5000);
    }
  }, [msgSuccess]);

  useEffect(() => {
    if (msgError) {
      setTimeout(() => {
        setMsgError(null);
      }, 5000);
    }
  }, [msgError]);

  const buscarParceiros = async (
    currentPage: number,
    perPage: number,
    searchNome ?: string,
    searchNomeResp ?: string,
    searchCnpj ?: string,                                     
    searchEmail ?: string,
    searchStatus?: number,
  ) => {

    setLoading(true);

    try {

      const parceiros = await findAllInstitutions(
        currentPage,
        perPage,
        searchNome,
        searchNomeResp,
        searchCnpj,
        searchEmail,
        searchStatus
      );

      setParceiros(parceiros.institutions);

      if (parceiros.pagination) {
        setTotalPages(Math.ceil(parceiros.pagination.total / perPage));
      }

      setPagination(parceiros.pagination);
      setLoading(false);

    } catch (error) {

      setMsgError('Erro ao listar os parceiros');
    }
  };

  const buscarParceirosResumo = async () => {

    try {

      const result = await findInstitutionsResumo();
      setParceirosResumo(result);

    } catch (error) {
      console.log('Erro ao consultar dados resumo');
      setParceirosResumo([]);
    }
  };

  const recarregarParceiros = () => {
    buscarParceiros(currentPage, perPage);
  };

  const filterParceiros = () => {
    buscarParceiros(
      currentPage,
      perPage,
      searchNome,
      searchNomeResp,
      searchCnpj,
      searchEmail,
      searchStatus
    );
  };

  const hesetFilter = () => {
    setSearchNome("");
    setSearchNomeResp("");
    setSearchCnpj("");
    setSearchEmail("");
    setSearchStatus(undefined);
    buscarParceiros(currentPage, perPage);
  };

  const inactivatePartner = async (id: number | null | undefined) => {

    if (!id) {
      throw('Parceiro não encontrado');
    }
    setLoadingConfirm(true);
    await inactivateInstitution(id);
    setLoadingConfirm(false);
    return;
  };

  const activatePartner = async (id: number | null | undefined) => {

    if (!id) {
      throw('Parceiro não encontrado');
    }

    setLoadingConfirm(true);
    await activateInstitution(id);
    setLoadingConfirm(false);
    return;
  };

  const inactivateMultipleInstitutions = async (ids: number[]) => {
    
    if (ids.length === 0) {
      throw('Nenhuma Instituição selecionada');
    }
    
    setLoadingConfirm(true);
    await inactivateInstitutions(ids);
    setLoadingConfirm(false);
    return;
  };

  const activateMultipleInstitutions = async (ids: number[]) => {
    
    if (ids.length === 0) {
      throw('Nenhuma Instituição selecionada');
    }
    
    setLoadingConfirm(true);
    await activateInstitutions(ids);
    setLoadingConfirm(false);
    return;
  };
  const handleExportPdf = async () => {
    try {
      setLoadingExport(true);

      const result = await findAllInstitutions(
        1,
        999999,
        searchNome,
        searchNomeResp,
        searchCnpj,
        searchEmail,
        searchStatus
      );

      const data = result.institutions;

      if (!data || data.length === 0) {
        setLoadingExport(false);
        setOpenExportPdf(false);
        setMsgError('não existem dados para serem exportados!');
        return;
      }

      const columns: ExportColumn[] = [
        { label: "ID", key: "id" },
        { label: "Nome", key: "nome" },
        { label: "CNPJ", key: "cnpj" },
        { label: "E-mail", key: "email" },
        { label: "Telefone", key: "telefone" },
        { label: "Responsável Nome", key: "resp_nome" },
        { label: "Responsável CPF", key: "resp_cpf" },
        { label: "Responsável E-mail", key: "resp_email" },
        { label: "Responsável Celular", key: "resp_celular" },
        { label: "Tipo", key: "tipo_instituicao" },
        { label: "Status", key: "ativo" },
        //{ label: "Usuários", key: "users" },
      ];

      const mappedData = data.map((item) => ({
        ...item,
        tipo_instituicao: item.institution_type?.nome || item.tipo || "",
        users: item.users ? JSON.stringify(item.users) : "",
      }));

      exportPDF(columns, mappedData, "parceiros.pdf");

      setLoadingExport(false);
      setOpenExportPdf(false);
    } catch (error) {
      setLoadingExport(false);
      setMsgError('não foi possível gerar o PDF!');
    }
  };

  const handleExportXls = async () => {
    try {
      setLoadingExport(true);

      const result = await findAllInstitutions(
        1,
        999999,
        searchNome,
        searchNomeResp,
        searchCnpj,
        searchEmail,
        searchStatus
      );

      const data = result.institutions;

      if (!data || data.length === 0) {
        setLoadingExport(false);
        setOpenExportXls(false);
        setMsgError('não existem dados para serem exportados!');
        return;
      }

      const columns: ExportColumn[] = [
        { label: "ID", key: "id" },
        { label: "Nome", key: "nome" },
        { label: "CNPJ", key: "cnpj" },
        { label: "E-mail", key: "email" },
        { label: "Telefone", key: "telefone" },
        { label: "Responsável Nome", key: "resp_nome" },
        { label: "Responsável CPF", key: "resp_cpf" },
        { label: "Responsável E-mail", key: "resp_email" },
        { label: "Responsável Celular", key: "resp_celular" },
        { label: "Tipo", key: "tipo_instituicao" },
        { label: "Status", key: "ativo" },
        //{ label: "Usuários", key: "users" },
      ];

      const mappedData = data.map((item) => ({
        ...item,
        tipo_instituicao: item.institution_type?.nome || item.tipo || "",
        users: item.users ? JSON.stringify(item.users) : "",
      }));

      exportXLSX(columns, mappedData, "parceiros.xlsx");

      setLoadingExport(false);
      setOpenExportXls(false);
    } catch (error) {
      setLoadingExport(false);
      setMsgError('não foi possível gerar o XLS!');
    }
  };

  return {
    msgError,
    msgSuccess,
    loading,
    loadingConfirm,
    loadingExport,
    parceiros,
    parceirosResumo,
    pagination,
    currentPage,
    perPage,
    totalPages,
    openExportPdf,
    setOpenExportPdf,
    openExportXls,
    setOpenExportXls,
    searchNome,
    setSearchNome,
    searchNomeResp,
    setSearchNomeResp,
    searchCnpj,
    setSearchCnpj,
    searchEmail,
    setSearchEmail,
    searchStatus,
    setSearchStatus,
    setMsgError,
    setMsgSuccess,
    setCurrentPage,
    setPerPage,
    buscarParceiros,
    buscarParceirosResumo,
    inactivatePartner,
    activatePartner,
    recarregarParceiros,
    inactivateMultipleInstitutions,
    activateMultipleInstitutions,
    filterParceiros,
    hesetFilter,
    handleExportPdf,
    handleExportXls,
  };

};
